import { render, staticRenderFns } from "./new-goods.vue?vue&type=template&id=2d6bbfbc&scoped=true&"
import script from "./new-goods.vue?vue&type=script&lang=js&"
export * from "./new-goods.vue?vue&type=script&lang=js&"
import style0 from "./new-goods.vue?vue&type=style&index=0&id=2d6bbfbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bbfbc",
  null
  
)

export default component.exports